/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Form_Aria_LabelInputs */

const en_style_guide_form_aria_label = /** @type {(inputs: Style_Guide_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style Guide Review`)
};

const fr_style_guide_form_aria_label = /** @type {(inputs: Style_Guide_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examen du guide de style`)
};

const de_style_guide_form_aria_label = /** @type {(inputs: Style_Guide_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stilrichtlinien-Überprüfung`)
};

const it_style_guide_form_aria_label = /** @type {(inputs: Style_Guide_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisione della guida di stile`)
};

const ru_style_guide_form_aria_label = /** @type {(inputs: Style_Guide_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор руководства по стилю`)
};

const es_style_guide_form_aria_label = /** @type {(inputs: Style_Guide_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisión de la guía de estilo`)
};

const zh_cn2_style_guide_form_aria_label = /** @type {(inputs: Style_Guide_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`风格指南审查`)
};

const ja_style_guide_form_aria_label = /** @type {(inputs: Style_Guide_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルガイドレビュー`)
};

const hi_style_guide_form_aria_label = /** @type {(inputs: Style_Guide_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड समीक्षा`)
};

const pt_pt2_style_guide_form_aria_label = /** @type {(inputs: Style_Guide_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisão do Guia de Estilo`)
};

/**
* | output |
* | --- |
* | "Style Guide Review" |
*
* @param {Style_Guide_Form_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_form_aria_label = /** @type {((inputs?: Style_Guide_Form_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Form_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_form_aria_label(inputs)
	if (locale === "de") return de_style_guide_form_aria_label(inputs)
	if (locale === "it") return it_style_guide_form_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_form_aria_label(inputs)
	if (locale === "es") return es_style_guide_form_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_form_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_form_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_form_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_form_aria_label(inputs)
	return en_style_guide_form_aria_label(inputs)
});